// Core functionality that should be available throughout the application
// This will replace some of the functionality previously in application.js

// Add core functionality here that should be available across all layouts
console.log("Core modules loaded successfully");

// Signal that core.js has been fully loaded
window.coreModuleLoaded = true;

// Export any functions that need to be used by other modules
export function ready(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

// Utility function for handling AJAX
export function ajaxRequest(method, url, data = null) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    
    // Include CSRF token
    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    if (token) {
      xhr.setRequestHeader('X-CSRF-Token', token);
    }
    
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(xhr.response);
      } else {
        reject(xhr.statusText);
      }
    };
    
    xhr.onerror = () => reject(xhr.statusText);
    
    xhr.send(data ? JSON.stringify(data) : null);
  });
}

// Self-test function to verify module loading is working
export function verifyModuleLoading() {
  console.log("Core module verification function called successfully");
  return true;
}